import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./Label.css";

export default function Label(props) {
  const className = classNames(
    styles.root,
    props.className,
    props.hidden ? styles.hidden : null
  );

  return <label {...props} className={className} />;
}

Label.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  htmlFor: PropTypes.string.isRequired,
  hidden: PropTypes.bool,
};
